import {Deserializable} from '../deserializable';

export  class NavItem implements Deserializable
{
  public  id: number;
  public  code: string;
  public  name: string;
  public  description: string;
  public  url: string;
  public  icon: string;
  public  position: number;
  public  parentId: number;
  public  type: number;
  public active: boolean;
  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
